import { RETAILER_RULE_SLUG } from "../rulesAndOutcomes/outcomes/retailerOutcome/retailerOutcomeUtils";
import { STORE_GROUP_RULE_SLUG } from "../rulesAndOutcomes/outcomes/storeOutcome/storeOutcomeUtils";
import { MILESTONE_GOAL_RULE_SLUG } from "../rulesAndOutcomes/outcomes/milestoneOutcome/milestoneGoalUtils";

export const OUTCOME_CONDITION_RULE_SLUGS = new Set([
  "survey-answer-matching-rule",
  RETAILER_RULE_SLUG,
  STORE_GROUP_RULE_SLUG,
]);

export { MILESTONE_GOAL_RULE_SLUG };

/**
 * Returns true for rules that are optional outcome rules:
 * - not hidden
 * - not a condition rule (survey, retailer, store)
 * - not the milestone-goal inline rule
 */
export const isOptionalOutcomeRule = (rule) =>
  rule?.hidden !== true &&
  !OUTCOME_CONDITION_RULE_SLUGS.has(rule?.slug) &&
  rule?.slug !== MILESTONE_GOAL_RULE_SLUG;
